export default {
	clientDetails: false,
	clientSettings: false,
	userClasses: [],
	userClassId: false,
	userClassLocations: [],
	selectedLocation: [],
	selectedAssetLocations: [],
	selectedAssetLocation: null,
	selectedDate: null,
	openingHoursForDate: {},
	currentRooms: [],
	roomDetailsById: {},
	assetCategory: [],
	assetGroup: [],
	assetType: [],
	asset: [],
	HTMLWidget: [],
	locations: [],
	showMap: false,
	isLoading: false
};
